import type { NotificationCardSwitcherProps } from "./notification-card-switcher.type";

import { NotificationAssignInterventionCard } from "@/modules/notification/notification-assign-intervention-card";
import { NotificationAssignProjectCard } from "@/modules/notification/notification-assign-project-card";
import { NotificationAsyncDeleteCard } from "@/modules/notification/notification-async-delete-card";
import { NotificationJobModuleCard } from "@/modules/notification/notification-job-module-card";
import { NotificationObservationCommentedCard } from "@/modules/notification/notification-observation-commented-card";
import { NotificationTransitionInterventionCard } from "@/modules/notification/notification-transition-intervention-card";
import { NotificationTransitionObservationCard } from "@/modules/notification/notification-transition-observation-card";

export const NotificationCardSwitcher = ({
  notification,
}: NotificationCardSwitcherProps) => {
  switch (notification.type) {
    case "async-delete-success":
    case "async-delete-failed":
      return <NotificationAsyncDeleteCard notification={notification} />;
    case "intervention-assign":
      return <NotificationAssignInterventionCard notification={notification} />;
    case "transition-intervention":
      return (
        <NotificationTransitionInterventionCard notification={notification} />
      );

    case "transition-observation":
      return (
        <NotificationTransitionObservationCard notification={notification} />
      );

    case "job-module-completed":
    case "job-module-failed":
      return <NotificationJobModuleCard notification={notification} />;

    case "observation-commented":
      return (
        <NotificationObservationCommentedCard notification={notification} />
      );

    case "project-assign":
      return <NotificationAssignProjectCard notification={notification} />;
    default:
      return null;
  }
};
